<script lang="ts">
	import { get } from 'svelte/store';
	import { format } from 'svelte-i18n';
	//Design system components
	import { ButtonV2 } from '@Shelly/shelly-design-system';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import DeviceInList from 'src/components/Lists/Devices/DeviceInList.svelte';
	//Components
	import EditDeviceWizard from 'src/components/Devices/DeviceWizard/EditDeviceWizard.svelte';
	import BluTrvStartAssociations from './BluTrvStartAssociations.svelte';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let showAddButton = true;
	export let showAssociationsModal = false;

	const deviceID = real_id(device.id);
	const _device = device;

	let waitForResponse = false;
	let inclusionStep = 1;

	let newTRVDevice: Device = null;
	const trvInitDevices: string[] = [];
	let trvDevices: string[] = Object.keys($devices)
		.filter((id) => new RegExp(`${deviceID}_22\\d{2}$`).test(id))
		.sort();
	trvDevices.forEach((i) => trvInitDevices.push(i));
	$: trvDevices = Object.keys($devices)
		.filter((id) => new RegExp(`${deviceID}_22\\d{2}$`).test(id))
		.sort();

	const addlistenerNewTRV = (devices: { [key: string]: Device }) => {
		if (inclusionStep == 2) {
			const newTrvDevices: string[] = Object.keys(devices).filter((id) =>
				new RegExp(`${deviceID}_22\\d{2}$`).test(id),
			);
			for (let i = 0; i < newTrvDevices.length; ++i) {
				const dev: Device = devices[newTrvDevices[i]];
				if (!trvInitDevices.includes(dev?.id)) {
					newTRVDevice = dev;
					showAssociationsModal = false;
					inclusionStep = 1;
					return;
				}
			}
		}
	};

	$: addlistenerNewTRV($devices);
</script>

{#if trvDevices?.length}
	{#each trvDevices as trvID}
		{@const device = get(devices)[trvID]}
		{#if device}
			<DeviceInList {device} hideSlotRight />
			<div class="mb-s"></div>
		{/if}
	{/each}
{/if}

{#if showAddButton}
	<ButtonV2
		size="m"
		class="mb-s"
		width="full"
		aria-label={$format('text_blu_trv_add_new', { default: 'Add New TRV Device' })}
		on:click={() => {
			inclusionStep = 1;
			showAssociationsModal = true;
		}}
		loading={waitForResponse}
	>
		{$format('text_blu_trv_add_new', {
			default: 'Add New TRV Device',
		})}
	</ButtonV2>
{/if}

{#if showAssociationsModal}
	<BluTrvStartAssociations
		device={_device}
		bind:showModal={showAssociationsModal}
		bind:inclusionStep
	/>
{/if}

{#if newTRVDevice}
	<EditDeviceWizard showModalEdit editDevice={newTRVDevice} on:finish={() => (newTRVDevice = null)} />
{/if}
